import React from 'react';
import './SingleColumn.less';
import { SecondKillComp } from '../../../widgets';
import autobind from 'autobind-decorator';
import { dateformat } from '../../../utils';

export interface SingleColumnPropType {
    prefixCls?: string;
    isApp?: any;
    data?: any;
    toAppDetail?: (data?: any) => void; // 跳转商品详情
    shopHomeJia: (data?: any) => void; // 加购物车
    shareProc: (id?: string) => void; // B端分享
}

export interface SingleColumnState {

}

/**
 * 单列横铺列表条目组件
 * @class SingleColumn
 * @extends {React.Component<SingleColumnPropType, SingleColumnState>}
 */
class SingleColumn extends React.Component<SingleColumnPropType, SingleColumnState> {
    static defaultProps = {
        prefixCls: 'single-column'
    };

    dataType: any = {
        '11': '开始秒杀',
        '12': '开始抢购',
        '21': '结束秒杀',
        '22': '结束抢购'
    };

    @autobind
    private _showText(data: any): any {
        const typeStr: string = '' + `${data.promotStatus}${data.type}`;
        return this.dataType[typeStr];
    }

    @autobind
    private _showTime(data: any): any {
        const typeStr: string = '' + `${data.promotStatus}${data.type}`;
        if (typeStr === '11' || typeStr === '12') {
            return data.startTime / 1000;
        } else if (typeStr === '21' || typeStr === '22') {
            return data.endTime / 1000;
        }
    }

    render() {
        const {prefixCls, isApp, data = {}, shopHomeJia, shareProc, toAppDetail} = this.props;
        const defaultStyles = {
            ellipsis: {
                WebkitBoxOrient: 'vertical'
            }
        };
        let isBClass = isApp ? '-b' : '';
        return (
            <div className={`${prefixCls}`}>
                <div className={`${prefixCls}-label-box`}>
                    {
                        data.labelImgList && data.labelImgList.map((item, index) => {
                            return (
                                <img src={item} key={index} alt=""/>
                            );
                        })
                    }
                </div>
                <div className={`${prefixCls}-img`} onClick={toAppDetail}>
                    <img src={data.mastermap} alt=""/>
                    {data.status == -1 && <div className={`${prefixCls}-lootAll`}>抢光了～</div>}
                    {
                        data.promotStatus !== 0 && data.promotStatus !== null && data.type !== 0 && (
                            <div className={`${prefixCls}-activeBox`}>
                                <SecondKillComp
                                    size='sm'
                                    text={this._showText(data)}
                                    date={dateformat(this._showTime(data), 'mm月dd日 HH:MM:ss')}
                                />
                            </div>
                        )
                    }
                </div>
                {
                    <div className={`${prefixCls}-content`}>
                        <div className={`${prefixCls}-selling-point` + isBClass} style={defaultStyles.ellipsis}
                             onClick={toAppDetail}>
                            {data.productAd}
                        </div>
                        <div className={`${prefixCls}-commodity-title` + isBClass} style={defaultStyles.ellipsis}
                             onClick={toAppDetail}>
                            {data.brandsName}·{data.productName}
                        </div>
                        <div className={`${prefixCls}-present-price` + isBClass} onClick={toAppDetail}>
                            <span className={`${prefixCls}-yuan`}>￥</span>
                            <span className={`${prefixCls}-price`}>
                                {data.price}
                            </span>
                            <div className={`${prefixCls}-delimit`}>
                                ￥{data.marketPrice}
                                <i/>
                            </div>
                        </div>
                        <div className={`${prefixCls}-btn-box`}>
                            <div className={`${prefixCls}-add-car-icon`} onClick={() => {
                                shopHomeJia(data);
                            }}>
                                <img
                                    src={require('../../../images/add-shop.png')}
                                    className={`${prefixCls}-btn-box-icon`}
                                    alt=""
                                />
                                加购物车
                            </div>
                            {
                                isApp ?
                                    <div className={`${prefixCls}-share-earn`} onClick={() => {
                                        shareProc(data);
                                    }}>
                                        <img
                                            src={require('../../../images/share-white.png')}
                                            className={`${prefixCls}-btn-box-icon`}
                                            alt=""
                                        />
                                        分享赚￥{data.commission}
                                    </div> :
                                    <div onClick={toAppDetail}>
                                        立即购买
                                    </div>
                            }
                        </div>
                    </div>
                }
            </div>
        );
    }
}

export default SingleColumn;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/widgets/specialItem/singleColumn/SingleColumn.tsx